<div class="center-content fade-in-animation">
  <div class="report-title">Métricas até o período: {{lastReportDate}}</div>

  <div class="card">
    <div class="card-content" style="display: flex">
      <div class="card-info">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
        <div class="card-title">
          Total de endereços de parceiros <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div> {{ (places[0]?.totalAddresses | number: '1.0-3') || '-'}}

        <div class="secondary-data">
          <div class="data-item">
            <span>Total de parceiros únicos <info-tooltip [description]="'Descrição'"></info-tooltip></span>
            <b>{{ (places[0]?.total | number: '1.0-3') || '-'}}</b>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <canvas id="partnersChart" width="750" height="260"></canvas>
      </div>
    </div>
  </div>

  <div class="report-title">Métricas até o período: {{lastReportDate}}</div>

  <div class="partners-cards">
    <div class="card">
      <div class="card-content">

        <div class="card-header">
          <h4 class="no-margin">Top 10 Parceiros</h4>
          <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div>

        <ngx-datatable
          class="auxiliary-table companies-table"
          [headerHeight]="'auto'"
          [rowHeight]="35"
          [columnMode]="columnModes.flex"
          [rows]="topPartnersRows"
          [columns]="topPartnersColumns">
        </ngx-datatable>

      </div>
    </div>

    <div class="card">
      <div class="card-content">

        <div class="card-header">
          <h4 class="no-margin">Top 5 Categorias</h4>
          <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div>

        <ngx-datatable
          class="auxiliary-table categories-table"
          [headerHeight]="'auto'"
          [rowHeight]="55"
          [columnMode]="columnModes.flex"
          [rows]="topCategoriesRows">
          <ngx-datatable-column name="" prop="categoryId" [flexGrow]="0.5">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <div class="category-icon" [ngStyle]="{ background: categoriesIcons[value]?.bgColor, color: categoriesIcons[value]?.color }">
                <i [classList]="categoriesIcons[value]?.iconClass"></i>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="" prop="category" [flexGrow]="1.8">
            <ng-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Visualizações" prop="views" [flexGrow]="1">
            <ng-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Cupons" prop="coupons" [flexGrow]="0.7">
            <ng-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>

      </div>
    </div>
  </div>
</div>
